<template>
  <v-container>
    <v-dialog v-model="dialog.delete" scrollable persistent width="350">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-information</v-icon>
          Informasi
          <v-btn class="mt-n1" icon dark top right absolute @click="resetForm">
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <p class="ma-0 body-1">
            Apakah anda yakin menghapus Acara
            <span class="font-weight-bold">
              {{ detail.eventName }}
            </span>
            ?
          </p>
          <v-alert
            v-if="error.message"
            text
            type="error"
            class="custom-alert my-4"
          >
            <p class="body-2 mb-0">
              {{ error.message }}
            </p>
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn
            small
            color="red"
            text
            elevation="0"
            :disabled="loadFormEvent"
            class="text-capitalize"
            @click="deleteEventHandler(detail.eventId)"
          >
            Hapus
          </v-btn>
          <v-btn
            small
            light
            color="light-green"
            elevation="0"
            :disabled="loadFormEvent"
            @click="resetForm"
            class="white--text text-capitalize"
          >
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.map" scrollable persistent width="500">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-map-legend</v-icon>
          Pilih Lokasi
          <v-btn
            class="mt-n1"
            icon
            dark
            top
            right
            absolute
            @click="resetFormMap"
          >
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <gmap-map
            :center="center"
            :zoom="15"
            :clickable="true"
            @click="updatePlace"
            class="_maps"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUi: false
            }"
          >
            <gmap-marker
              :position="center"
              :draggable="true"
              @drag="updatePlace"
              @click="center = center"
            >
            </gmap-marker>
          </gmap-map>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn
            small
            color="#fff"
            elevation="0"
            class="text-capitalize grey--text text--darken-1"
            @click="resetFormMap"
          >
            Batal
          </v-btn>
          <v-btn
            small
            light
            color="light-green"
            elevation="0"
            @click="saveFormMap"
            class="white--text text-capitalize"
          >
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.filter" persistent scrollable max-width="600">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-filter</v-icon>
          Filter list acara
          <v-btn class="mt-n1" icon dark top right absolute @click="resetForm">
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <v-form ref="formFilter">
            <p class="subtitle-2 mb-3 text--secondary">
              Range tanggal Acara
            </p>
            <v-menu
              ref="start"
              min-width="290px"
              max-width="290px"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="picker.start"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  dense
                  readonly
                  color="light-green"
                  prepend-inner-icon="mdi-calendar-month"
                  label="Tanggal Mulai"
                  clearable
                  @click:clear="formFilter.start = ''"
                  v-model="formFilter.start"
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                color="light-green"
                v-model="formFilter.start"
                @input="picker.start = false"
              >
              </v-date-picker>
            </v-menu>
            <v-menu
              ref="end"
              min-width="290px"
              max-width="290px"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="picker.end"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  dense
                  readonly
                  color="light-green"
                  prepend-inner-icon="mdi-calendar-month"
                  label="Tanggal Selesai"
                  clearable
                  @click:clear="formFilter.end = ''"
                  v-model="formFilter.end"
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                color="light-green"
                v-model="formFilter.end"
                @input="picker.end = false"
              >
              </v-date-picker>
            </v-menu>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn
            small
            color="#fff"
            elevation="0"
            class="text-capitalize grey--text text--darken-1"
            @click.stop="dialog.filter = false"
          >
            Batal
          </v-btn>
          <v-btn
            small
            light
            color="orange lighten-1"
            elevation="0"
            @click="resetFilter"
            class="white--text text-capitalize"
          >
            Reset
          </v-btn>
          <v-btn
            small
            light
            color="light-green"
            elevation="0"
            @click="saveFilter"
            class="white--text text-capitalize"
          >
            Filter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.create" persistent scrollable max-width="600">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-home-map-marker</v-icon>
          {{ selectedPage === 'update' ? 'Ubah' : 'Tambah' }} acara
          <v-btn class="mt-n1" icon dark top right absolute @click="resetForm">
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <ValidationObserver ref="observer">
            <v-form ref="form" :readonly="loadFormEvent">
              <p class="subtitle-2 mb-3 text--secondary">
                Informasi acara
              </p>
              <ValidationProvider
                name="Nama"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  dense
                  outlined
                  label="Nama"
                  color="light-green"
                  v-model="form.name"
                  :error-messages="formErrors.name || errors"
                >
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider
                name="participant"
                rules="required|min_0:0"
                v-slot="{ errors }"
              >
                <v-currency-field
                  dense
                  outlined
                  color="light-green"
                  suffix="Orang"
                  label="Total Peserta"
                  v-model="form.participant"
                  :error-messages="formErrors.participant || errors"
                />
              </ValidationProvider>
              <p class="subtitle-2 mb-3 text--secondary">
                Tanggal acara
              </p>
              <v-menu
                ref="start"
                min-width="290px"
                max-width="290px"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                :close-on-content-click="false"
                v-model="picker.date"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    outlined
                    dense
                    readonly
                    color="light-green"
                    prepend-inner-icon="mdi-calendar-month"
                    placeholder="Tanggal Acara"
                    clearable
                    @click:clear="form.date = ''"
                    v-model="form.date"
                    v-on="on"
                  >
                  </v-text-field>
                </template>
                <v-date-picker
                  color="light-green"
                  v-model="form.date"
                  @input="picker.date = false"
                />
              </v-menu>
              <p class="subtitle-2 mb-3 text--secondary">
                Deskripsi acara
              </p>
              <ValidationProvider
                name="Deskripsi"
                rules="required"
                v-slot="{ errors }"
              >
                <v-textarea
                  dense
                  outlined
                  label="Deskripsi"
                  color="light-green"
                  v-model="form.content"
                  :error-messages="formErrors.content || errors"
                />
              </ValidationProvider>
              <p class="subtitle-2 mb-3 text--secondary">
                Lokasi Acara
              </p>
              <v-row no-gutters align="start" class="mb-7">
                <v-col
                  cols="8"
                  style="min-width: 100px;"
                  class="flex-grow-0 flex-shrink-1"
                >
                  <div
                    class="v-input v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined d-block"
                    :class="{
                      'error--text v-input--has-state':
                        formErrors.location || error.location
                    }"
                  >
                    <div
                      class="v-input__control"
                      style="height: 40px;border-radius: 4px 0 0 4px;"
                    >
                      <div class="v-input__slot">
                        <fieldset
                          aria-hidden="true"
                          style="height: 40px;top: 0;"
                        >
                          <legend style="width: 0px;"></legend>
                        </fieldset>
                        <div class="v-text-field__slot">
                          <label
                            for="input-147"
                            class="v-label theme--light error--text"
                            style="left: 0px; right: auto; position: absolute;"
                          >
                          </label>
                          <gmap-autocomplete
                            placeholder="Alamat lengkap"
                            :value="form.location"
                            :select-first-on-enter="true"
                            @change="validateAddress"
                            @blur="validateAddress"
                            @place_changed="setPlace"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="error.location || formErrors.location"
                      class="v-text-field__details mt-1"
                    >
                      <div
                        class="v-messages theme--light error--text"
                        role="alert"
                      >
                        <div class="v-messages__wrapper">
                          <div class="v-messages__message">
                            {{
                              formErrors.location
                                ? formErrors.location
                                : 'Kolom tidak boleh kosong'
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="4" class="flex-shrink-0">
                  <v-btn
                    style="border-radius: 0px 4px 4px 0px;"
                    elevation="0"
                    height="40"
                    block
                    color="grey darken-1"
                    class="text-capitalize white--text"
                    @click="dialog.map = true"
                  >
                    Pilih
                    {{ $vuetify.breakpoint.name !== 'xs' ? 'Dari Peta' : '' }}
                  </v-btn>
                </v-col>
              </v-row>
              <div class="mb-5">
                <p class="subtitle-2 mb-2 text--secondary">Lampiran</p>
                <div>
                  <vue-dropzone
                    ref="ImageVueDropzone"
                    id="dropzone"
                    :destroy-dropzone="true"
                    :use-custom-slot="true"
                    :options="dropzoneMultipleFileOptions"
                    @vdropzone-success="handleUploadSuccess"
                    @vdropzone-removed-file="handleRemoveFile"
                    @vdropzone-mounted="dropzoneMounted"
                  >
                    <div class="dropzone-custom-content">
                      <v-icon x-large>mdi-file-image-outline</v-icon>
                      <h3 class="dropzone-custom-title mt-2">
                        Tarik dan letakkan <br />
                        gambar Anda disini!
                      </h3>
                      <div class="subtitle">atau klik disini</div>
                    </div>
                  </vue-dropzone>
                </div>
              </div>
            </v-form>
          </ValidationObserver>
          <v-alert
            v-if="error.message"
            text
            type="error"
            class="custom-alert my-4"
          >
            <p class="body-2 mb-0">
              {{ error.message }}
            </p>
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn
            small
            color="#fff"
            elevation="0"
            :disabled="loadFormEvent"
            class="text-capitalize grey--text text--darken-1"
            @click="resetForm"
          >
            Batal
          </v-btn>
          <v-btn
            small
            light
            color="light-green"
            elevation="0"
            :disabled="loadFormEvent"
            :loading="loadFormEvent"
            @click="saveForm"
            class="white--text text-capitalize"
          >
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <div class="text--secondary">List Acara</div>
          </v-card-title>
          <v-card-subtitle class="mt-3">
            <v-sheet class="d-sm-flex align-center justify-space-between">
              <v-btn
                :block="$vuetify.breakpoint.name === 'xs'"
                color="light-green"
                class="text-capitalize"
                dark
                elevation="2"
                @click.stop="dialog.create = true"
              >
                <v-icon small>mdi-plus</v-icon> Acara
              </v-btn>
              <v-sheet class="d-sm-flex mt-4 mt-sm-0 align-center">
                <v-text-field
                  dense
                  outlined
                  v-model="search"
                  hide-details
                  placeholder="Cari Acara . . ."
                  clearable
                  color="light-green"
                  prepend-inner-icon="mdi-magnify"
                  class="mb-4 mb-sm-0 mr-sm-2"
                  :full-width="$vuetify.breakpoint.name === 'xs'"
                >
                </v-text-field>
                <v-row dense class="py-0">
                  <v-col>
                    <v-btn
                      :block="$vuetify.breakpoint.name === 'xs'"
                      color="grey lighten-3"
                      class="text-capitalize grey--text text--darken-1"
                      elevation="0"
                      @click.stop="
                        dialog.filter = true;
                        formAddressName = 'form';
                      "
                    >
                      Filter
                    </v-btn>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-sheet>
            <v-container class="pa-0" v-if="filter.filtered">
              <v-row dense>
                <v-col cols="12" class="mt-2">
                  Filter By
                </v-col>
                <v-col class="py-0">
                  <v-chip-group show-arrows>
                    <v-chip
                      v-if="filter.start && filter.end"
                      close
                      @click:close="
                        formFilter.start = null;
                        formFilter.end = null;
                        saveFilter();
                      "
                    >
                      Tanggal {{ filter.start }} ~ {{ filter.end }}
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
            </v-container>
          </v-card-subtitle>
          <v-card-text>
            <v-divider class="my-2" />
            <v-skeleton-loader
              class="ma-auto"
              :loading="loadEvents"
              transition="fade-transition"
              :tile="false"
              type="table-row"
              v-for="index in loadEvents ? 10 : 1"
              :key="index"
            >
              <v-data-table
                v-show="events.length >= 1"
                :headers="headers"
                mobile-breakpoint="1"
                hide-default-footer
                :items="events"
                fixed-header
                min-height="250px"
                :height="
                  $vuetify.breakpoint.name !== 'xs' && filter.filtered
                    ? 'calc(100vh - 60vh)'
                    : $vuetify.breakpoint.name !== 'xs'
                    ? 'calc(100vh - 50vh)'
                    : ''
                "
              >
                <template v-slot:[`item.aksi`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        color="green"
                        elevation="0"
                        class="text-capitalize white--text ma-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="toDetail(item)"
                      >
                        <v-icon small>mdi-alert-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Detail</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        color="blue darken-1"
                        elevation="0"
                        class="text-capitalize white--text ma-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="updateEventHandler(item)"
                      >
                        <v-icon small>mdi-square-edit-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        color="red"
                        elevation="0"
                        class="text-capitalize white--text ma-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          detail = item;
                          dialog.delete = true;
                        "
                      >
                        <v-icon small>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.eventLocation`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{ item.eventLocation | addressLong }}
                      </span>
                    </template>
                    <span>
                      {{ item.eventLocation }}
                    </span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.eventDate`]="{ item }">
                  {{ item.eventDate | date }}
                </template>
              </v-data-table>
            </v-skeleton-loader>
            <div
              class="text-center text--secondary"
              v-show="!loadEvents && events.length < 1"
            >
              <v-icon
                style="font-size: 60px; margin-top: 1.5em"
                color="light-green"
              >
                mdi-close-circle-outline
              </v-icon>
              <p class="headline font-weight-bold mt-2 mb-1">Data kosong</p>
              <p>Data yang Anda cari tidak ada disini</p>
            </div>
          </v-card-text>
          <v-card-actions class="pb-6 px-6">
            <v-row>
              <v-col
                cols="5"
                v-if="
                  paginationEvents.totalData > 0 &&
                    $vuetify.breakpoint.name !== 'xs'
                "
              >
                <div class="body-2 font-weight-bold mt-4">
                  Total {{ paginationEvents.totalData }} data
                </div>
              </v-col>
              <v-col
                v-if="paginationEvents.totalPage > 1"
                :cols="$vuetify.breakpoint.name !== 'xs' ? '7' : '12'"
              >
                <div class="float-sm-right">
                  <v-pagination
                    v-model="page"
                    :length="paginationEvents.totalPage"
                    :total-visible="5"
                    color="light-green"
                    @input="getEventsHandler()"
                    circle
                  >
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import debounce from 'lodash.debounce';

import dropzone from '@/mixins/dropzone';
import event from '@/mixins/event';
import area from '@/mixins/area';

export default {
  mixins: [event, area, dropzone],

  data() {
    return {
      search: '',
      detail: {},
      center: {
        lat: -7.7161435,
        lng: 110.3266482
      },
      defaultArea: true,
      error: {
        location: ''
      },
      formAddressName: 'form',
      page: 1,
      filter: {
        filtered: false,
        start: null,
        end: null
      },
      formFilter: {
        start: null,
        end: null
      },
      picker: {
        start: false,
        end: false,
        date: false
      },
      form: {
        id: '',
        name: null,
        date: null,
        content: null,
        participant: null,
        location: null,
        latitude: null,
        longitude: null,
        attachment: [],
        attachmentFull: []
      },
      isDropzoneMounted: false,
      dialog: {
        create: false,
        delete: false,
        filter: false,
        map: false
      },
      selectedPage: '',
      headers: [
        {
          text: 'Aksi',
          value: 'aksi',
          align: 'start',
          width: 100,

          sortable: false,
          class: 'font-weight-black body-2'
        },
        {
          text: 'Nama',
          width: 150,
          class: 'font-weight-black body-2',
          value: 'eventName'
        },
        {
          text: 'Lokasi',
          width: 300,
          class: 'font-weight-black body-2',
          value: 'eventLocation'
        },
        {
          text: 'Tanggal',
          width: 100,
          class: 'font-weight-black body-2',
          value: 'eventDate'
        }
      ]
    };
  },
  watch: {
    search: {
      handler: debounce(function() {
        this.page = 1;
        this.getEventsHandler();
      }, 500),
      immediate: true
    },
    'dialog.create': {
      handler(val) {
        if (val) {
          if (this.isDropzoneMounted) {
            this.form.attachmentFull.forEach((item) => {
              this.$refs.ImageVueDropzone.manuallyAddFile(
                { size: 123, name: item.name, type: 'image/png' },
                item.url.compressed
              );
            });
          }
        }
      }
    }
  },
  methods: {
    async getEventsHandler() {
      const filters = [
        {
          type: 'string',
          field: 'event_name',
          value: this.search,
          comparison: '<>'
        },
        {
          field: 'event_created_datetime',
          type: 'date',
          value:
            this.filter.end && this.filter.end.length > 0
              ? `${this.filter.start}::${this.filter.end}`
              : '',
          comparison: 'bet'
        }
      ];
      const payload = {
        filters,
        page: this.page
      };
      await this.getEvents(payload);
    },
    handleUploadSuccess(file, response) {
      this.form.attachment.push(response.data.results.url.compressed);
      this.form.attachmentFull.push(response.data.results);
    },
    handleRemoveFile(file) {
      const index = this.form.attachment.indexOf(file.url);
      const index2 = this.form.attachmentFull.findIndex(
        (item) => item.url.compressed === file.url
      );
      this.form.attachment.splice(index, 1);
      this.form.attachmentFull.splice(index2, 1);
    },
    toDetail(item) {
      this.$router.push({
        name: 'event-detail',
        params: { id: item.eventId }
      });
    },
    setPlace(place) {
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      this.form.latitude = place.geometry.location.lat();
      this.form.longitude = place.geometry.location.lng();
      this.form.location = place.formatted_address;
      this.error.location = '';
    },
    updatePlace(location) {
      this.center = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      };
    },
    validateAddress(e) {
      if (e && e.type === 'change') {
        this.form.location = '';
        this.error.location = true;
        return false;
      }
      if (!this.form.location) {
        this.error.location = true;
        return false;
      }
      this.error.location = '';
      return true;
    },
    saveFilter() {
      this.page = 1;
      this.filter = {
        start: this.formFilter.start,
        end: this.formFilter.end
      };
      if (this.formFilter.start && this.formFilter.end) {
        this.filter.filtered = true;
      }
      this.resetForm();
      this.getEventsHandler();
    },
    resetFilter() {
      this.page = 1;
      this.filter = {
        filtered: false,
        start: null,
        end: null
      };
      this.formFilter = {
        start: null,
        end: null
      };
      this.resetForm();
      this.getEventsHandler();
    },
    resetForm() {
      this.clearError();
      if (this.$refs.observer) this.$refs.observer.reset();
      this.dialog = {
        create: false,
        delete: false,
        filter: false,
        map: false
      };
      this.formAddressName = 'form';
      this.form = {
        id: '',
        name: null,
        date: null,
        content: null,
        participant: null,
        location: null,
        latitude: null,
        longitude: null,
        attachment: [],
        attachmentFull: []
      };
      if (this.$refs.ImageVueDropzone) {
        this.$refs.ImageVueDropzone.removeAllFiles();
      }
      this.selectedPage = '';
      this.detail = {};
      this.error = {
        location: ''
      };
      this.center = {
        lat: -7.8031634,
        lng: 110.3336452
      };
    },
    async saveForm() {
      this.clearError();
      const isValid = await this.$refs.observer.validate();
      const addressValid = this.validateAddress();
      if (isValid && addressValid) {
        try {
          const attachment = JSON.stringify(this.form.attachmentFull);
          if (this.form.id) {
            await this.updateEvent({ ...this.form, attachment }, this.form.id);
          } else {
            await this.createEvent({ ...this.form, attachment });
          }
          this.page = 1;
          this.resetForm();
          await this.getEventsHandler();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
      }
    },
    updateEventHandler(event) {
      this.selectedPage = 'update';
      this.form = {
        id: event.eventId,
        name: event.eventName,
        date: event.eventDate,
        content: event.eventContent,
        participant: event.eventParticipant,
        location: event.eventLocation,
        latitude: parseFloat(event.eventLatitude),
        longitude: parseFloat(event.eventLongitude),
        attachmentFull: event.eventAttachment || [],
        attachment: event.eventAttachment.map((item) => item.url.compressed)
      };
      this.center = {
        lat: parseFloat(event.eventLatitude),
        lng: parseFloat(event.eventLongitude)
      };
      this.dialog.create = true;
      this.showPage = true;
    },
    dropzoneMounted() {
      this.isDropzoneMounted = true;
      this.form.attachmentFull.forEach((item) => {
        this.$refs.ImageVueDropzone.manuallyAddFile(
          { size: 123, name: item.name, type: 'image/png' },
          item.url.compressed
        );
      });
    },
    resetFormMap() {
      this.dialog.map = false;
    },
    saveFormMap() {
      this.form.latitude = this.center.lat;
      this.form.longitude = this.center.lng;
      // eslint-disable-next-line no-undef
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ latLng: this.center }, (result, status) => {
        // eslint-disable-next-line no-undef
        if (status === google.maps.GeocoderStatus.OK) {
          this.form.location = result[0].formatted_address;
        }
      });
      this.error.location = '';
      this.resetFormMap();
    },
    async deleteEventHandler(id) {
      this.clearError();
      try {
        await this.deleteEvent(id);
        this.page = 1;
        this.resetForm();
        await this.getEventsHandler();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }
  }
};
</script>
